import { createContext, useContext } from 'react';
import warning from 'warning';
var ListStateContext = /*#__PURE__*/createContext();
export default ListStateContext;
export var useListStateContext = function useListStateContext() {
  var context = useContext(ListStateContext);

  if (process.env.NODE_ENV !== 'production') {
    warning(context !== undefined, 'useListStateContext must be used inside of a ListStateContext Provider.');
  }

  return context;
};